import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";
import { Link } from "@inertiajs/react";
import WebpImage from "./WebpImage";
import FrontText from "../FrontText";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import { useTranslation } from "react-i18next";
import FrontSmallContactButton from "../Buttons/FrontSmallContactButton";
import { Icon } from "@iconify/react";

const FrontWarehousesLoop = ({warehouses}) => {
    const { t, i18n } = useTranslation();

    if (warehouses.length > 0) {
        return (
            <Container>
                <Row className="gap-y-15">
                    {warehouses.map((elem, index) => (
                        <Column xl={6} lg={6} md={6} sm={6} key={elem.name + '-' + index}>
                            <div
                                className="flex flex-col h-full"
                            >
                            <div className="flex h-full lg:flex-row flex-col">

                                <div className="lg:w-2/5 w-full">
                                    <Link href={resolveLocaleRoute('front.warehouses.single', { province: elem.get_region.slug, slug: elem.slug }, i18n.resolvedLanguage)} title={t('alts.showDetails') + ' - ' + elem.name}>
                                        <WebpImage
                                            className="lg:rounded-tl-10 lg:rounded-t-none rounded-t-10 h-full object-cover w-full"
                                            sources={[
                                                {
                                                    width: 768,
                                                    path: `/storage/warehouses/${elem.gallery_main.substring(0, elem.gallery_main.lastIndexOf('.'))}-300`,
                                                    mime: elem.gallery_main.split('.').pop(),
                                                },
                                                {
                                                    width: 1,
                                                    path: `/storage/warehouses/${elem.gallery_main.substring(0, elem.gallery_main.lastIndexOf('.'))}-700`,
                                                    mime: elem.gallery_main.split('.').pop(),
                                                },
                                            ]}
                                            alt={elem.name}
                                            fallback={`/storage/warehouses/${elem.gallery_main}`}
                                            seo={{
                                                width: 660,
                                                height: 430,
                                            }}
                                            lazy
                                        />
                                    </Link>
                                </div>
                                <div className="lg:w-3/5 h-full w-full flex flex-col text-left border-E0E0E0 border lg:border-t border-t-0 lg:border-l-0 p-c18 lg:rounded-tr-10 bg-hover transition-all ease-in-out duration-300">
                                    <FrontText
                                        textSize="20/24"
                                        className="font-bold text-heading-blue mb-3 hover-white transition-all ease-in-out duration-300"
                                        customLinkStyles
                                    >
                                        <Link href={resolveLocaleRoute('front.warehouses.single', { province: elem.get_region.slug, slug: elem.slug }, i18n.resolvedLanguage)} title={t('alts.showDetails') + ' - ' + elem.name} className="hover:text-light-yellow transition-all ease-in-out duration-300">
                                            <span>{elem.name}</span>
                                        </Link>
                                    </FrontText>

                                    <div className="flex items-center gap-x-c10 shrink-0 mb-6">
                                        <svg
                                            width="18"
                                            height="26"
                                            viewBox="0 0 18 26"
                                            fill="t"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g id="icon - localisation">
                                                <g>
                                                    <ellipse
                                                        id="Ellipse 4"
                                                        cx="9"
                                                        cy="24"
                                                        rx="7"
                                                        ry="2"
                                                        fill="#30548A"
                                                    />
                                                    <g>
                                                        <g>
                                                            <ellipse
                                                                cx="8.99962"
                                                                cy="7.875"
                                                                rx="8.21739"
                                                                ry="7.875"
                                                                fill="#30548A"
                                                            />
                                                            <path
                                                                d="M9 24L1.20577 10.5L16.7942 10.5L9 24Z"
                                                                fill="#30548A"
                                                            />
                                                        </g>
                                                        <circle
                                                            className="hover-change transition-all duration-300 ease-in-out"
                                                            cx="9"
                                                            cy="7.5"
                                                            r="4.5"
                                                            fill="white"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <FrontText
                                            textSize="16/20"
                                            className="text-standard-black font-medium hover-white transition-all ease-in-out duration-300"
                                            customLinkStyles
                                        >
                                            {/* =================== [Dodatek, odkomentować link po akceptacji] =================== */}
                                            <Link href={resolveLocaleRoute('front.warehouses', {searchRegion: elem.city_slug ? elem.city_slug : i18n.resolvedLanguage == 'pl' ? elem.get_region.slug : elem.get_region.slug_en}, i18n.resolvedLanguage)} className="hover:text-yellow transition-all ease-in-out duration-200">
                                                <span>{elem.city ? elem.city : elem.get_region.name}</span>
                                            </Link>
                                        </FrontText>
                                    </div>

                                    <div className="mt-auto">


                                    <FrontText
                                        textSize="14/17"
                                        className="text-standard-black hover-white transition-all ease-in-out duration-300"
                                    >
                                        <p>
                                            {t(
                                                "warehouses.rentAndTotalArea"
                                            )}
                                        </p>
                                    </FrontText>

                                    
                                    <Link
                                        href={resolveLocaleRoute('front.warehouses.single', {
                                            province: elem.get_region.slug,
                                            slug: elem.slug
                                        }, i18n.resolvedLanguage)+'#advisors'}
                                        title={t(
                                            "warehouses.contactAdvisor"
                                        )}
                                        rel="nofollow"
                                    >
                                        <FrontSmallContactButton type="" className="md:w-auto w-full mt-2 justify-center">
                                            <span>{t('warehouses.contactAdvisor')}</span>
                                        </FrontSmallContactButton>
                                    </Link>
                                    </div>
                                </div>
                            </div>
                                <Link rel="nofollow" href={resolveLocaleRoute('front.warehouses.single', { province: elem.get_region.slug, slug: elem.slug }, i18n.resolvedLanguage)} title={t('alts.showDetails') + ' - ' + elem.name} className="bg-light-blue text-white hover:bg-blue-classic block transition-all ease-in-out duration-300 rounded-b-10">
                                    <div className="gap-[10px] flex items-center px-5 lg:py-c10 py-2 justify-center">
                                        <FrontText
                                            textSize={"16/20-m-14/17"}
                                            className="font-semibold"
                                        >
                                            <span>{t('alts.showDetails')}</span>
                                        </FrontText>

                                        <Icon
                                            icon={"material-symbols:arrow-right-alt"}
                                            width={24}
                                            height={24}
                                        />
                                    </div>
                                </Link>
                            </div>
                        </Column>
                    ))}
                </Row>
            </Container>
        )
    }
}

export default FrontWarehousesLoop;